import React, { Component } from 'react';
import { searchTraderProviderLoadingOperatorLegalEntityByName } from '../../actions/actionHelpers/endpoints';
import { AutoCompleteSelectField } from '../';

const getDataSource = async (value) => {
  const { data } =
    await searchTraderProviderLoadingOperatorLegalEntityByName(value);
  return data.map((item) => ({
    value: item.registrationCode,
    label: `${item.companyName} [${item.registrationCode}]`,
  }));
};

class AutoCompleteAccountsRegCodeField extends Component {
  render() {
    return (
      <AutoCompleteSelectField {...this.props} getDataSource={getDataSource} />
    );
  }
}

export default AutoCompleteAccountsRegCodeField;
